import store from '@/store'

import async from 'async'

import restResource from '@/technical/restResource'

import http from 'axios'

import Vue from 'vue'

export default {
  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  // Блок управленческой информации по работе serverData. подключен ли сервер, какие данные загружены и тд
  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // isLoaded: false, // true когда все данные с сервера подгружены успешно - ПОКА ЭТО РАБОТАЕТ КАК ЕДИНЫЙ ПАРАМЕТЕР У commonData.isLoaded

  eventsBus: new Vue(),

  // status: 'not connected',

  debugMsg: '(пусто)',

  loadingDataStatus: {
    types: {INITIAL: 0, LOADING: 1, LOADED: 2, ERROR: 3},

    mainCommonData: 0,
    appSettings: 0, // true когда все данные подгружены успешно. необходим, потому что по пустому полю appSettings, tasks и тд не понятно это еще не скачено или уже пришел пустой ответ
    places: 0,
    events: 0,
    eventsMembers: 0,
    users: 0
  },

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  mainCommonDataLoadedSetTrue: function () {
    var thisRef = this
    thisRef.loadingDataStatus.mainCommonData = thisRef.loadingDataStatus.types.LOADED
    setTimeout(function () {
      thisRef.eventsBus.$emit('mainCommonDataLoaded')
    }, 1)
  },

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  appSettings: {},
  appSettingsReload: function (cb) {
    this.appSettings = Object.assign({}, {}) // обнуляем, но чтобы это видел Vue
    this.loadingDataStatus.appSettings = this.loadingDataStatus.types.LOADING

    var thisRef = this

    async.parallel({
      commonSettings: function (asyncCallback) {
        http.get(store.getters.appSettings.server.settings + store.getters.appSettings.server.commonSettingsCriteria)
        .then(function (response) {
          if (response.data[0] != null) {
            // thisRef.akcii = JSON.parse(response.data)[0].value
            thisRef.appSettings.common = response.data[0].value
            thisRef.appSettings.common.userGroupsMap = {}
            for (var prop in thisRef.appSettings.common.userGroups) {
              thisRef.appSettings.common.userGroupsMap[thisRef.appSettings.common.userGroups[prop].id] = thisRef.appSettings.common.userGroups[prop]
            }
          }
          asyncCallback()
        })
        .catch() // сам вызывает asyncCallback
      },
      eventsSettings: function (asyncCallback) {
        http.get(store.getters.appSettings.server.settings + store.getters.appSettings.server.eventsSettingsCriteria)
        .then(function (response) {
          if (response.data[0] != null) {
            thisRef.appSettings.events = response.data[0].value
          }
          asyncCallback()
        })
        .catch() // сам вызывает asyncCallback
      }
    }, function (error) {
      // console.log('serverData.appSettingsReload')
      // console.log(thisRef.appSettings)
      // console.log(error)
      if (!error) {
        thisRef.loadingDataStatus.appSettings = thisRef.loadingDataStatus.types.LOADED
        setTimeout(function () {
          thisRef.eventsBus.$emit('appSettingsChanged', {method: 'read', initiator: 'serverData.appSettingsReload'}) // read - значит метод read из CRUD т е первональное получение от сервера всего списка данных
        }, 1)
      } else thisRef.loadingDataStatus.appSettings = thisRef.loadingDataStatus.types.ERROR

      cb(error)
    })
  },

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  // все images нужны только чтобы хранить массив updatedAt привязанный к id картинки чтобы использовать в timestamp и браузер автоматом обновлял картинку
  // при создании в updatedAt int тиков от 1970, потом там datetime. объект может создаваться и тут и через realtime.
  // обновляется через realtime. мы просто сохраняем картинку на сервер и все клиенты (и включая этот кто загружал ее на сервер, получают обновление по realtime)
  fileEntitiesMap: {}, // слово fileEntities вместо images и слово Map добавлено для унификации realtime чтобы он обновил значение по типу ассоциированного массива
  imagesCreateEntity: function (fileEntityId) {
    this.fileEntitiesMap[fileEntityId] = {val: {}} // по типу resource только для унификации в realtime а так не нужен ибо fileEntity не сохраняется на сервер
    this.fileEntitiesMap[fileEntityId].val = {id: fileEntityId, updatedAt: Date.now()} // остальные параметры не важны, на сервер мы не сохраняем. ща тут int (тик от 1970), после realtime будет datetime но пофиг главное что новое значение
  },
  imagesGetURL: function (fileEntityId) {
    var timestamp = ''
    // все юзеры без аватара и места, эвенты без картинки (place-edit-new например) показывают пустую картинки через вызов этого метода с fileEntityId = undefined
    // и эту ситуацию обрабатываем что пропускаем timestamp и url -> fileEntity/getFile?id=undefined&timestamp=
    if (fileEntityId != null) {
      // важное место: если объекта еще нет в images а его url запрашивают, то просто тут его и создаем. или он уже есть или пришел через realtime
      if (this.fileEntitiesMap[fileEntityId] == null) this.imagesCreateEntity(fileEntityId)
      timestamp = this.fileEntitiesMap[fileEntityId].val.updatedAt
      return store.getters.appSettings.server.fileEntityResource + '/getFile?id=' + fileEntityId + '&timestamp=' + timestamp
    } else return ''
  },

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  places: [],
  placesMap: {},
  placesGetOneById: function (id) {
    for (var i = 0; i < this.places.length; i++) {
      if (this.places[i].val.id === id) {
        return this.places[i]
      }
    }
    return null
  },
  placesOnDestroyDelegates: [],
  placesOnDestroy: function (deletedRecord, cb) {
    async.each(this.placesOnDestroyDelegates, function (delegate, callback) {
      delegate(deletedRecord, callback)
    }, function (error) {
      cb(error)
    })
  },
  placesReload: function (cb) {
    // var something = []
    // так как мы работаем с единым объектом-массивом serverData.something, то просто присвоить ему [] нельзя
    // а ниже будет push, занчит сначала надо обнулить
    this.places.splice(0, this.places.length)
    this.loadingDataStatus.places = this.loadingDataStatus.types.LOADING

    var thisRef = this
    // var systemDocs = []
    var placeResource = restResource(store.getters.appSettings.server.placeResource)
    placeResource.query()
    .then(function (response) {
      if (response.data == null) return cb('что-то не так')
      thisRef.places.splice(0, thisRef.places.length) // Еще раз обнуляем - защита если пока запрашивались данные от сервера, был еще один вызов этих данных
      // users[0] = {Name: '- Выберите автора -', id: 0}
      for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
        var onePlaceResource = restResource(store.getters.appSettings.server.placeResource)
        onePlaceResource.val = response.data[itemIndx]
        thisRef.places.push(onePlaceResource)
        thisRef.placesMap[onePlaceResource.val.id] = onePlaceResource
        // if (onePlaceResource.val.images != null) {
        //  for (var i = 0; i < onePlaceResource.val.images.length; i++) thisRef.fileEntitiesMapCreateOne(onePlaceResource.val.images[i])
        // }
      }
      thisRef.loadingDataStatus.places = thisRef.loadingDataStatus.types.LOADED
      setTimeout(function () {
        thisRef.eventsBus.$emit('placesChanged', {method: 'read', initiator: 'serverData.placesReload'}) // read - значит метод read из CRUD т е первональное получение от сервера всего списка данных
      }, 1)
      cb()
    })
    .catch(function (err) {
      thisRef.loadingDataStatus.places = thisRef.loadingDataStatus.types.ERROR
      cb(err)
    })
  },

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  events: [],
  eventsMap: {},
  /* eventsGetOneById: function (id) {
    for (var i = 0; i < this.events.length; i++) {
      if (this.events[i].val.id === id) {
        return this.events[i]
      }
    }
    return null
  }, */
  eventsOnDestroyDelegates: [],
  eventsOnDestroy: function (deletedRecord, cb) {
    async.each(this.eventsOnDestroyDelegates, function (delegate, callback) {
      delegate(deletedRecord, callback)
    }, function (error) {
      cb(error)
    })
  },
  eventsReload: async function (cb) {
    this.loadingDataStatus.events = this.loadingDataStatus.types.LOADING
    this.loadingDataStatus.eventsMembers = this.loadingDataStatus.types.LOADING
    this.loadingDataStatus.users = this.loadingDataStatus.types.LOADING

    if (store.getters.activeUser != null) {
      this.users.push(store.getters.activeUser)
      this.usersMap[store.getters.activeUser.id] = store.getters.activeUser
    }

    var thisRef = this
    try {
      var data = await http.get(store.getters.appSettings.server.getMyEventsTimeline)

      // var something = []. так как мы работаем с единым объектом-массивом serverData.something, то просто присвоить ему [] нельзя
      // а ниже будет push, занчит сначала надо обнулить. обнулять выше http.get может привести к ошибке если два раза одновременно вызвано eventsReload, то
      // в момент http.get(getMyEventsTimeline) одного, второй вызовется. оба сделают splice, а потом в двух колбэках http.get вся лента задвоится
      this.events.splice(0, this.events.length)
      this.eventsMembers.splice(0, this.eventsMembers.length)
      this.users.splice(0, this.users.length)

      if ((data == null) || (data.data == null) || (data.data.events == null) || (data.data.eventsUsers == null) || (data.data.eventsMembers == null)) {
        thisRef.loadingDataStatus.events = thisRef.loadingDataStatus.types.ERROR
        thisRef.loadingDataStatus.eventsMembers = thisRef.loadingDataStatus.types.ERROR
        thisRef.loadingDataStatus.users = thisRef.loadingDataStatus.types.ERROR
        return cb('Произошла ошибка при получении от сервера ленты событий: пустые данные')
      }
      for (var itemIndx = 0; itemIndx < data.data.events.length; itemIndx++) {
        var oneEventResource = restResource(store.getters.appSettings.server.eventResource)
        oneEventResource.val = data.data.events[itemIndx]
        thisRef.events.push(oneEventResource)
        thisRef.eventsMap[oneEventResource.val.id] = oneEventResource
        // if (oneEventResource.val.body.images != null) {
        //  for (var i = 0; i < oneEventResource.val.body.images.length; i++) thisRef.fileEntitiesMapCreateOne(oneEventResource.val.body.images[i])
        // }
      }
      for (itemIndx = 0; itemIndx < data.data.eventsMembers.length; itemIndx++) {
        var oneEventMemberResource = restResource(store.getters.appSettings.server.eventMemberResource)
        oneEventMemberResource.val = data.data.eventsMembers[itemIndx]
        thisRef.eventsMembers.push(oneEventMemberResource)
      }
      for (itemIndx = 0; itemIndx < data.data.eventsUsers.length; itemIndx++) {
        if ((store.getters.activeUser != null) && (data.data.eventsUsers[itemIndx].id === store.getters.activeUser.id)) continue
        thisRef.users.push(data.data.eventsUsers[itemIndx])
        thisRef.usersMap[data.data.eventsUsers[itemIndx].id] = data.data.eventsUsers[itemIndx]
        // if (data.data.eventsUsers[itemIndx].body.avatar != null) thisRef.fileEntitiesMapCreateOne(data.data.eventsUsers[itemIndx].body.avatar)
      }
      this.eventsRecalcAllEventsMembering()
      thisRef.loadingDataStatus.events = thisRef.loadingDataStatus.types.LOADED
      thisRef.loadingDataStatus.eventsMembers = thisRef.loadingDataStatus.types.LOADED
      thisRef.loadingDataStatus.users = thisRef.loadingDataStatus.types.LOADED
      setTimeout(function () {
        thisRef.eventsBus.$emit('eventsChanged', {method: 'read', initiator: 'serverData.eventsReload'}) // read - значит метод read из CRUD т е первональное получение от сервера всего списка данных
        thisRef.eventsBus.$emit('eventsMembersChanged', {method: 'read', initiator: 'serverData.eventsReload'}) // read - значит метод read из CRUD т е первональное получение от сервера всего списка данных
        thisRef.eventsBus.$emit('usersChanged', {method: 'read', initiator: 'serverData.eventsReload'}) // read - значит метод read из CRUD т е первональное получение от сервера всего списка данных
      }, 1)
      cb()
    } catch (e) {
      // var something = []. так как мы работаем с единым объектом-массивом serverData.something, то просто присвоить ему [] нельзя
      // а ниже будет push, занчит сначала надо обнулить. обнулять выше http.get может привести к ошибке если два раза одновременно вызвано eventsReload, то
      // в момент http.get(getMyEventsTimeline) одного, второй вызовется. оба сделают splice, а потом в двух колбэках http.get вся лента задвоится
      this.events.splice(0, this.events.length)
      this.eventsMembers.splice(0, this.eventsMembers.length)
      this.users.splice(0, this.users.length)

      thisRef.loadingDataStatus.events = thisRef.loadingDataStatus.types.ERROR
      thisRef.loadingDataStatus.eventsMembers = thisRef.loadingDataStatus.types.ERROR
      thisRef.loadingDataStatus.users = thisRef.loadingDataStatus.types.ERROR
      return cb('Произошла ошибка при получении от сервера ленты событий: ' + e)
    }
  },
  eventsRecalcAllEventsMembering: function () {
    for (var itemIndx = 0; itemIndx < this.events.length; itemIndx++) {
      var event = this.events[itemIndx]
      this.eventsRecalcEventMembering(event)
    }
  },
  eventsRecalcEventMembering: function (event) {
    // console.log('eventsRecalcEventMembering')
    if (event == null) return // может быть вызван из realtime для события по которому прошло обновление eventMember, но которого вообще нет в timeline и оно нас не интересует
    if (event.membering == null) {
      Vue.set(event, 'membering', {members: [], possible: [], cancels: []}) // без vue.set новые свойства vue не видит  и не видит что массивы внутри изменились, хотя он следит за splice и push (https://ru.vuejs.org/v2/guide/list.html и http://ru.vuejs.org/v2/guide/reactivity.html#Особенности-отслеживания-изменений)
    } else {
      event.membering.members.splice(0, event.membering.members.length)
      event.membering.possible.splice(0, event.membering.possible.length)
      event.membering.cancels.splice(0, event.membering.cancels.length)
    }
    for (var itemIndx = 0; itemIndx < this.eventsMembers.length; itemIndx++) {
      var eventMember = this.eventsMembers[itemIndx]
      if (eventMember.val.refToEvent !== event.val.id) continue
      if (eventMember.val.status !== 1) {
        event.membering.cancels.push(eventMember)
      } else if ((eventMember.val.status === 1) && (eventMember.val.participationType === 1)) {
        event.membering.members.push(eventMember)
      } else if ((eventMember.val.status === 1) && (eventMember.val.participationType === 2)) {
        event.membering.possible.push(eventMember)
      }
    }
  },
  eventsReloadMyEvents: async function (cb) {
    var thisRef = this
    try {
      var data = await http.get(store.getters.appSettings.server.getMyEvents)

      // не обнуляем (splice(0)) списки events, eventsMembers, users
      // статусы загрузки данных не трогам, ибо уже timeline подгрузилось и можно отображать. свои события просто добавляем асинхронно
      if ((data == null) || (data.data == null) || (data.data.events == null) || (data.data.eventsUsers == null) || (data.data.eventsMembers == null)) {
        thisRef.loadingDataStatus.events = thisRef.loadingDataStatus.types.ERROR
        thisRef.loadingDataStatus.eventsMembers = thisRef.loadingDataStatus.types.ERROR
        thisRef.loadingDataStatus.users = thisRef.loadingDataStatus.types.ERROR
        return cb('Произошла ошибка при получении от сервера ленты событий: пустые данные')
      }
      for (var itemIndx = 0; itemIndx < data.data.events.length; itemIndx++) {
        var oneEventResource = restResource(store.getters.appSettings.server.eventResource)
        oneEventResource.val = data.data.events[itemIndx]
        if (thisRef.eventsMap[oneEventResource.val.id] == null) {
          thisRef.events.push(oneEventResource)
          thisRef.eventsMap[oneEventResource.val.id] = oneEventResource
        }
      }
      for (itemIndx = 0; itemIndx < data.data.eventsMembers.length; itemIndx++) {
        var oneEventMemberResource = restResource(store.getters.appSettings.server.eventMemberResource)
        oneEventMemberResource.val = data.data.eventsMembers[itemIndx]
        if (thisRef.eventsMap[oneEventMemberResource.val.refToEvent == null]) { // если в events уже есть событие то и все его eventsMembers тоже есть и не добавляем
          thisRef.eventsMembers.push(oneEventMemberResource)
        }
      }
      for (itemIndx = 0; itemIndx < data.data.eventsUsers.length; itemIndx++) {
        if ((store.getters.activeUser != null) && (data.data.eventsUsers[itemIndx].id === store.getters.activeUser.id)) continue
        if (thisRef.usersMap[data.data.eventsUsers[itemIndx].id] == null) {
          thisRef.users.push(data.data.eventsUsers[itemIndx])
          thisRef.usersMap[data.data.eventsUsers[itemIndx].id] = data.data.eventsUsers[itemIndx]
        }
      }
      this.eventsRecalcAllEventsMembering()
      setTimeout(function () {
        thisRef.eventsBus.$emit('eventsChanged', {method: 'read', initiator: 'serverData.eventsReload'}) // read - значит метод read из CRUD т е первональное получение от сервера всего списка данных
        thisRef.eventsBus.$emit('eventsMembersChanged', {method: 'read', initiator: 'serverData.eventsReload'}) // read - значит метод read из CRUD т е первональное получение от сервера всего списка данных
        thisRef.eventsBus.$emit('usersChanged', {method: 'read', initiator: 'serverData.eventsReload'}) // read - значит метод read из CRUD т е первональное получение от сервера всего списка данных
      }, 1)
      cb()
    } catch (e) {
      thisRef.loadingDataStatus.events = thisRef.loadingDataStatus.types.ERROR
      thisRef.loadingDataStatus.eventsMembers = thisRef.loadingDataStatus.types.ERROR
      thisRef.loadingDataStatus.users = thisRef.loadingDataStatus.types.ERROR
      return cb('Произошла ошибка при получении от сервера ленты событий: ' + e)
    }
  },

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  users: [],
  usersMap: {},
  usersLoadEventMemberUnknownUser: function (data, cb) {
    if (this.eventsMap[data.record.refToEvent] != null) { // нас не интересует изменения по событиям которых даже в таймлайне нет
      if (this.usersMap[data.record.refToUser] != null) { // пропускаем загрузку юзера если он уже у нас есть
        cb()
      } else {
        var thisRef = this
        // грузим одного автора (user) от чьего имени создался eventMember но его до этого не было в timeline и следовательно нет данных по нему
        http.get(store.getters.appSettings.server.userResource + '/' + data.record.refToUser)
        .then(function (response) {
          // thisRef.eventMembering.loadingUsersDone = true
          var anUser = response.data[0]
          if (anUser == null) cb('serverData.usersLoadEventMemberUnknownUser: Internal Error') // нет такого пользователя !!!!!!!! но что делать? при отображении произойдет ошибка. неверная обработка ситуации
          if (thisRef.usersMap[anUser.id] != null) { // update existing. пока запрос шел и возвращался с сервера, в event-компоненте например могли уже сделать юзера-объект-пустышку с этим id (чтоб сразу отобразить)
            var existingUser = thisRef.usersMap[anUser.id]
            // existingUser = Object.assign({}, anUser)
            for (var prop in anUser) if (prop !== 'body') Vue.set(existingUser, prop, anUser[prop])
            existingUser.body = Object.assign({}, anUser.body)
          } else { // add as new one
            thisRef.users.push(anUser)
            thisRef.usersMap[anUser.id] = anUser
          }
          cb()
        })
        .catch(function (error) {
          cb(error)
        })
      }
    }
  },
  /* usersOnDestroyDelegates: [],
  usersOnDestroy: function (deletedRecord, cb) {
    async.each(this.usersOnDestroyDelegates, function (delegate, callback) {
      delegate(deletedRecord, callback)
    }, function (error) {
      cb(error)
    })
  },
  usersReload: function (cb) {
    // var something = []
    // так как мы работаем с единым объектом-массивом serverData.something, то просто присвоить ему [] нельзя
    // а ниже будет push, занчит сначала надо обнулить
    this.users.splice(0, this.users.length)
    this.loadingDataStatus.users = this.loadingDataStatus.types.LOADING

    var thisRef = this
    // var systemDocs = []
    var eventResource = restResource(store.getters.appSettings.server.user)
    eventResource.query()
    .then(function (response) {
      if (response.data == null) return cb('что-то не так')
      thisRef.users.splice(0, thisRef.users.length) // Еще раз обнуляем - защита если пока запрашивались данные от сервера, был еще один вызов этих данных
      // users[0] = {Name: '- Выберите автора -', id: 0}
      for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
        thisRef.users.push(response.data[itemIndx])
        thisRef.usersMap[response.data[itemIndx].id] = response.data[itemIndx]
      }
      thisRef.loadingDataStatus.users = thisRef.loadingDataStatus.types.LOADED
      setTimeout(function () {
        thisRef.eventsBus.$emit('usersChanged', {method: 'read', initiator: 'serverData.usersReload'}) // read - значит метод read из CRUD т е первональное получение от сервера всего списка данных
      }, 1)
      cb()
    })
    .catch(function (err) {
      thisRef.loadingDataStatus.users = thisRef.loadingDataStatus.types.ERROR
      cb(err)
    })
  },
  */

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

  eventsMembers: []
  /* eventsMembersGetEventMembersByEventId: function (id) {
    var res = []
    for (var i = 0; i < this.eventsMembers.length; i++) {
      if (this.eventsMembers[i].val.refToEvent === id) {
        res.push(this.eventsMembers[i])
      }
    }
    return res
  } */
  /* eventsMembersOnDestroyDelegates: [],
  eventsMembersOnDestroy: function (deletedRecord, cb) {
    async.each(this.eventsMembersOnDestroyDelegates, function (delegate, callback) {
      delegate(deletedRecord, callback)
    }, function (error) {
      cb(error)
    })
  },
  eventsMembersReload: function (cb) {
    // var something = []
    // так как мы работаем с единым объектом-массивом serverData.something, то просто присвоить ему [] нельзя
    // а ниже будет push, занчит сначала надо обнулить
    this.eventsMembers.splice(0, this.eventsMembers.length)
    this.loadingDataStatus.eventsMembers = this.loadingDataStatus.types.LOADING

    var thisRef = this
    // var systemDocs = []
    var eventsMemberResource = restResource(store.getters.appSettings.server.eventMemberResource)
    eventsMemberResource.query()
    .then(function (response) {
      if (response.data == null) return cb('что-то не так')
      thisRef.eventsMembers.splice(0, thisRef.eventsMembers.length) // Еще раз обнуляем - защита если пока запрашивались данные от сервера, был еще один вызов этих данных
      // users[0] = {Name: '- Выберите автора -', id: 0}
      for (var itemIndx = 0; itemIndx < response.data.length; itemIndx++) {
        var oneEventsMemberResource = restResource(store.getters.appSettings.server.eventMemberResource)
        oneEventsMemberResource.val = response.data[itemIndx]
        thisRef.eventsMembers.push(oneEventsMemberResource)
      }
      thisRef.loadingDataStatus.eventsMembers = thisRef.loadingDataStatus.types.LOADED
      setTimeout(function () {
        thisRef.eventsBus.$emit('eventsMembersChanged', {method: 'read', initiator: 'serverData.eventsMembersReload'}) // read - значит метод read из CRUD т е первональное получение от сервера всего списка данных
      }, 1)
      cb()
    })
    .catch(function (err) {
      thisRef.loadingDataStatus.eventsMembers = thisRef.loadingDataStatus.types.ERROR
      cb(err)
    })
  } */

  // ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

}



// WEBPACK FOOTER //
// ./src/store/serverData.js